import { ENV, authFetch, parseResponse, SUCCESSARRAY } from "../utils";

function createSettingsFormData(data) {
  const formData = new FormData();

  const payload = {
    removeHeroBanner: data.removeHeroBanner === true,
  };

  // Los dos campos de la leyenda ("Estamos trabajando para servirte
  // mejor...") son independientes del banner de imagen de arriba: solo
  // se incluyen en la petición si de verdad se están guardando (así el
  // guardado del banner de imagen no toca la leyenda, y viceversa).
  if (data.maintenanceBannerActive !== undefined) {
    payload.maintenanceBannerActive = data.maintenanceBannerActive === true;
  }

  if (data.maintenanceBannerMessage !== undefined) {
    payload.maintenanceBannerMessage = data.maintenanceBannerMessage;
  }

  formData.append("data", JSON.stringify(payload));

  if (data.heroBanner instanceof File) {
    formData.append("heroBanner", data.heroBanner);
  }

  return formData;
}

export class Settings {
  async getSettings() {
    const url = `${ENV.API_URL}/${ENV.ENDPOINTS.SETTINGS.SETTINGS}`;

    const response = await authFetch(url);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async updateSettings(data) {
    const url = `${ENV.API_URL}/${ENV.ENDPOINTS.SETTINGS.SETTINGS}`;

    const params = {
      method: "PATCH",
      body: createSettingsFormData(data),
    };

    const response = await authFetch(url, params);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }
}
